module.exports = __webpack_public_path__ + "img/fast-transport-belt.a80c7294.png";